import L from 'leaflet';

// Generate Observation SVG icon
const createObservationIcon = () => {
  const svgContent = `
    <svg width="226" height="336" viewBox="0 0 226 336" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base -->
      <path d="M203 123.75 C203 80.565 168.435 45 123.75 45 S44.5 80.565 44.5 123.75 c0 43.185 79.25 173.25 79.25 173.25 s79.25-130.065 79.25-173.25 z" fill="#0d3825"/>

      <!-- Icon background circle -->
      <circle cx="123.75" cy="123.75" r="52.47" fill="white"/>
      <circle cx="123.75" cy="123.75" r="37.8" fill="white"/>

      <!-- Observation icon (scaled and centered) -->
      <g transform="translate(123.75, 123.75) scale(2.2) translate(-30, -30)">
        <g transform="scale(0.1333)">
          <g transform="translate(0, 450) scale(0.1, -0.1)" fill="#0d3825">
            <path d="M1605 2851 c-48 -23 -49 -24 -302 -269 -238 -229 -271 -279 -289 -442 -9 -83 24 -198 81 -285 70 -107 196 -179 335 -191 237 -22 439 138 485 383 18 91 30 105 140 157 168 80 301 73 467 -26 73 -43 68 -35 99 -168 54 -230 280 -381 514 -342 182 30 320 160 369 348 20 77 20 105 0 191 -30 133 -53 161 -399 492 -84 81 -147 132 -180 147 -129 60 -277 0 -336 -136 -23 -53 -35 -59 -86 -39 -34 13 -154 45 -204 53 -37 7 -135 -10 -229 -39 -102 -31 -108 -31 -121 1 -24 59 -32 73 -66 108 -50 51 -89 68 -168 72 -55 4 -79 0 -110 -15z m720 -271 c17 -11 40 -38 50 -59 15 -34 16 -45 5 -71 -30 -72 -104 -104 -167 -71 -83 42 -95 133 -25 191 44 36 89 39 137 10z m-703 -138 c70 -33 143 -104 176 -169 48 -94 48 -230 -1 -327 -27 -55 -112 -137 -172 -166 -44 -22 -64 -25 -160 -25 -103 0 -113 2 -160 29 -99 56 -156 124 -189 220 -57 173 39 382 205 443 30 11 61 23 69 26 8 4 49 5 91 4 61 -3 89 -10 141 -35z m1544 21 c187 -63 288 -227 256 -416 -14 -82 -50 -144 -117 -206 -75 -69 -123 -86 -245 -86 -120 0 -163 15 -243 85 -163 144 -167 382 -10 535 93 91 243 127 359 88z"/>
            <path d="M1362 2398 c-73 -29 -135 -87 -171 -160 -36 -71 -44 -152 -14 -146 10 2 22 25 34 65 30 108 88 169 192 203 38 13 52 22 52 36 0 26 -30 27 -93 2z"/>
            <path d="M2952 2398 c-73 -29 -135 -87 -171 -160 -36 -71 -44 -152 -15 -146 11 2 23 24 34 64 27 98 104 184 180 200 49 11 71 24 68 42 -5 24 -35 24 -96 0z"/>
            <path d="M2188 2839 c-38 -20 -76 -64 -64 -76 3 -3 23 -1 44 6 38 13 161 11 215 -4 35 -9 35 4 0 39 -56 56 -130 70 -195 35z"/>
          </g>
        </g>
      </g>
    </svg>
  `;

  return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent);
};

export const IconObservation = () => {
  var icon = new L.Icon({
    iconUrl: createObservationIcon(),
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [94, 104],
    iconAnchor: [34, 75],
    className: 'custom-icon-marker observation-marker'
  });

  return icon;
};